// import ShortDate from "~/lib/dates/short-date";
// import { Project } from "~/types";

// interface ProjectStartEndDatesProps {
//   project: Project;
//   theme?: string;
//   location: string;
//   placeholdersHidden: boolean;
// }

// export default function ProjectStartEndDates({
//   project,
//   theme,
//   location,
//   placeholdersHidden,
// }: ProjectStartEndDatesProps) {
//   const projectDatesEmpty =
//     project.start_date === null && project.completed === null ? true : false;

//   const showTwoDates =
//     (location === "project_page" ||
//     location === "user_profile") &&
//     project.completed !== null &&
//     project.start_date !== null &&
//     project.start_date !== project.completed
//       ? true
//       : false;

//   // const showOneDate = {
//   //   if(showTwoDates === false && project.start_date === null) {
//   //     return "end_date"
//   //   } else if (showTwoDates === false && project.completed === null)
//   //     return "start_date"
//   //   } else {
//   //     console.log("error")
//   //     return null;
//   //   }

//   return (
//     <>
//       {projectDatesEmpty ? null : (
//         <div
//           className={`font-semibold  dark:text-white ${
//             project.type !== null && location === "project_page"
//               ? "border-gray-300 dark:border-gray-400 sm:border-r sm:pr-2"
//               : ""
//           }`}
//         >
//           {projectDatesEmpty ? null : (
//             <div className="flex">
//               <div
//                 className={`
//                 ${
//                   location === "project_page"
//                     ? "text-sm font-semibold"
//                     : "text-xs"
//                 }
//                 ${theme === "dark" ? "text-gray-400" : "text-gray-500"}`}
//               >
//                 {placeholdersHidden ? (
//                   <ShortDate dateString={project.start_date} />
//                 ) : (
//                   "Project Date"
//                 )}
//               </div>

//               {showTwoDates ? (
//                 <div
//                   className={`relative h-0 px-1 text-gray-500 ${
//                     location === "project_page"
//                       ? "text-sm"
//                       : "text-xs"
//                   }`}
//                 >
//                   -
//                 </div>
//               ) : null}

//               {/* Only show if dates are different */}
//               {showTwoDates ? (
//                 <div
//                   className={`${
//                     location === "project_page"
//                       ? "text-sm font-semibold"
//                       : "text-xs"
//                   } ${theme === "dark" ? "text-gray-400" : "text-gray-500"}`}
//                 >
//                   <ShortDate dateString={project.completed} />
//                 </div>
//               ) : null}
//             </div>
//           )}
//         </div>
//       )}
//     </>
//   );
// }

import ShortDate from "~/lib/dates/short-date";
import { Project } from "~/types";

interface ProjectStartEndDatesProps {
  project: Project;
  theme?: string;
  location: string;
  placeholdersHidden: boolean;
}

export default function ProjectStartEndDates({
  project,
  theme,
  location,
  placeholdersHidden,
}: ProjectStartEndDatesProps) {
  const showDates = location === "project_page" || location === "user_profile";

  return (
    <>
      {project.start_date === null && project.completed === null ? (
        !placeholdersHidden ? (
          <div
            className={`skeleton-text  font-semibold ${
              location === "project_page"
                ? "mb-3 border-none pr-2 text-sm sm:mb-0 sm:border-r sm:border-solid"
                : ""
            }`}
          >
            Project Date
          </div>
        ) : null
      ) : (
        <div
          className={`font-semibold  dark:text-white ${
            project.type !== null && location === "project_page"
              ? "border-gray-300 dark:border-gray-400 sm:border-r sm:pr-2"
              : ""
          }`}
        >
          <div className="flex">
            <div
              className={` 
              ${
                location === "project_page"
                  ? "text-sm font-semibold"
                  : "text-xs"
              }
              ${theme === "dark" ? "text-gray-400" : "text-gray-500"}`}
            >
              <ShortDate dateString={project.start_date || project.completed} />
            </div>

            {showDates &&
            project.start_date !== null &&
            project.completed !== null ? (
              <>
                <div
                  className={`relative h-0 px-1 text-gray-500 ${
                    location === "project_page" ? "text-sm" : "text-xs"
                  }`}
                >
                  -
                </div>
                <div
                  className={`${
                    location === "project_page"
                      ? "text-sm font-semibold"
                      : "text-xs"
                  } ${theme === "dark" ? "text-gray-400" : "text-gray-500"}`}
                >
                  <ShortDate dateString={project.completed} />
                </div>
              </>
            ) : null}
          </div>
        </div>
      )}
    </>
  );
}
